var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "row roomy align-stretch margin-bottom-2xl",
      attrs: { id: "other" },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "column-12 tablet:column-6 laptop:column-4 margin-bottom-2xl laptop:margin-bottom-0",
        },
        [
          _c(
            "article",
            {
              staticClass: "card roomy yellow",
              staticStyle: { height: "100%" },
            },
            [
              _c(
                "div",
                { staticClass: "header padding-y-4xl" },
                [
                  _c("font-awesome-icon", {
                    attrs: {
                      icon: _vm.$v6.solid.faTrademark,
                      size: "3x",
                      "fixed-width": "",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "section text-left size-sm" }, [
                _c("h3", { staticClass: "h4" }, [_vm._v("Brand Icons")]),
                _vm._v(" "),
                _c(
                  "p",
                  [
                    _vm._v("\n          All\n          "),
                    _c(
                      "site-link",
                      {
                        attrs: {
                          to: _vm.$search({ iconCollections: ["brands"] }),
                        },
                      },
                      [_vm._v("brand icons")]
                    ),
                    _vm._v(
                      "\n          are trademarks of their respective owners. The use of these trademarks does not indicate endorsement of the trademark holder by Font Awesome, nor\n          vice versa.\n          "
                    ),
                    _c("strong", [
                      _vm._v(
                        "Please do not use brand logos for any purpose except to represent the company, product, or service to which they refer"
                      ),
                    ]),
                    _vm._v("\n          .\n        "),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "column-12 tablet:column-6 laptop:column-4 margin-bottom-2xl laptop:margin-bottom-0",
        },
        [
          _c(
            "article",
            { staticClass: "card roomy teal", staticStyle: { height: "100%" } },
            [
              _c(
                "div",
                { staticClass: "header padding-y-4xl" },
                [
                  _c("font-awesome-icon", {
                    attrs: {
                      icon: _vm.$v6.solid.faSunrise,
                      size: "3x",
                      "fixed-width": "",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "section text-left size-sm" }, [
                _c("h3", { staticClass: "h4" }, [
                  _vm._v("Kickstarter Backer or Pre-order?"),
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  [
                    _vm._v(
                      "\n          If so, you might have one of our older types of licenses. While our license policy has changed since then, our commitment to the one you have\n          hasn't. You've got the same license you had when you backed or pre-ordered. Read up on\n          "
                    ),
                    _c(
                      "site-link",
                      {
                        attrs: {
                          to: {
                            name: "support",
                            hash: "#font-awesome-5-kickstarter-pre-order-licenses",
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            all of the details of your license and how we'll support it\n          "
                        ),
                      ]
                    ),
                    _vm._v("\n          .\n        "),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "column-12 tablet:column-6 laptop:column-4" }, [
        _c(
          "article",
          { staticClass: "card roomy blue", staticStyle: { height: "100%" } },
          [
            _c(
              "div",
              { staticClass: "header padding-y-4xl" },
              [
                _c("font-awesome-icon", {
                  attrs: {
                    icon: _vm.$v6.solid.faCircleQuestion,
                    size: "3x",
                    "fixed-width": "",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "section text-left size-sm" }, [
              _c("h3", { staticClass: "h4" }, [_vm._v("Questions")]),
              _vm._v(" "),
              _c(
                "p",
                [
                  _vm._v(
                    "\n          Didn't see the answer to your question? Read through\n          "
                  ),
                  _c(
                    "site-link",
                    {
                      attrs: {
                        to: { name: "support", hash: "#the-pro-license" },
                      },
                    },
                    [_vm._v("our answers to common License questions")]
                  ),
                  _vm._v("\n          .\n        "),
                ],
                1
              ),
              _vm._v(" "),
              _c("p", [
                _vm._v("\n          Still need help?\n          "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "mailto:hello@fontawesome.com?subject=Font Awesome License question",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.supportLinkClicked("license_view")
                      },
                    },
                  },
                  [_vm._v("Contact us")]
                ),
                _vm._v("\n          .\n        "),
              ]),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }